export const PLATFORMS = {
  ACC: 'acc',
  BIM360: 'bim360',
  CPA: 'cpa',
} as const;

export type Platforms = typeof PLATFORMS;
export type Platform = Platforms[keyof Platforms];

export const ENVS = {
  QA: 'QA',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION',
} as const;

export type Envs = typeof ENVS;
export type Env = Envs[keyof Envs];

export const APIGEE_URL: Record<Env, string> = {
  [ENVS.QA]: 'https://developer-stg.api.autodesk.com',
  [ENVS.STAGING]: 'https://developer-stg.api.autodesk.com',
  [ENVS.PRODUCTION]: 'https://developer.api.autodesk.com',
};

export const OXYGEN_URL: Record<Env, string> = {
  [ENVS.QA]: 'https://accounts-staging.autodesk.com',
  [ENVS.STAGING]: 'https://accounts-staging.autodesk.com',
  [ENVS.PRODUCTION]: 'https://accounts.autodesk.com',
};

export const USER_PROFILE_URL: Record<Env, string> = {
  [ENVS.QA]: 'https://profile-stg.autodesk.com',
  [ENVS.STAGING]: 'https://profile-stg.autodesk.com',
  [ENVS.PRODUCTION]: 'https://profile.autodesk.com',
};

export const BC_HOSTNAMES: Record<Env, string> = {
  [ENVS.QA]: '',
  [ENVS.STAGING]: 'app-stage.buildingconnected.com',
  [ENVS.PRODUCTION]: 'app.buildingconnected.com',
};

export const BIM360_ADMIN_URL: Record<Env, string> = {
  [ENVS.QA]: `${APIGEE_URL[ENVS.QA]}/ea-api-qa`,
  [ENVS.STAGING]: `${APIGEE_URL[ENVS.STAGING]}/ea-api`,
  [ENVS.PRODUCTION]: `${APIGEE_URL[ENVS.PRODUCTION]}/ea-api`,
};

export const ADMIN_API_URL: Record<Env, string> = {
  [ENVS.QA]: `${APIGEE_URL[ENVS.QA]}/bim360-qa/admin`,
  [ENVS.STAGING]: `${APIGEE_URL[ENVS.STAGING]}/bim360/admin`,
  [ENVS.PRODUCTION]: `${APIGEE_URL[ENVS.PRODUCTION]}/bim360/admin`,
};

export const ADMIN_CONSTRUCTION_API_URL: Record<Env, string> = {
  [ENVS.QA]: `${APIGEE_URL[ENVS.QA]}/construction-qa/admin`,
  [ENVS.STAGING]: `${APIGEE_URL[ENVS.STAGING]}/construction/admin`,
  [ENVS.PRODUCTION]: `${APIGEE_URL[ENVS.PRODUCTION]}/construction/admin`,
};

export const DOCS_API_V1_URL: Record<Env, string> = {
  [ENVS.QA]: `${APIGEE_URL[ENVS.QA]}/ea-dm-qa/v1`,
  [ENVS.STAGING]: `${APIGEE_URL[ENVS.STAGING]}/dm-staging/v1`,
  [ENVS.PRODUCTION]: `${APIGEE_URL[ENVS.PRODUCTION]}/dm/v1`,
};

export const RELATIONSHIP_API_URL: Record<Env, string> = {
  [ENVS.QA]: `${APIGEE_URL[ENVS.QA]}/bim360/relationship-dev`,
  [ENVS.STAGING]: `${APIGEE_URL[ENVS.STAGING]}/bim360/relationship`,
  [ENVS.PRODUCTION]: `${APIGEE_URL[ENVS.PRODUCTION]}/bim360/relationship`,
};

export const REPORTS_V2_URL: Record<Env, string> = {
  [ENVS.QA]: `${APIGEE_URL[ENVS.QA]}/reports-qa/v2`,
  [ENVS.STAGING]: `${APIGEE_URL[ENVS.STAGING]}/reports/v2`,
  [ENVS.PRODUCTION]: `${APIGEE_URL[ENVS.PRODUCTION]}/reports/v2`,
};

export const FORMS_API_URL: Record<Env, string> = {
  [ENVS.QA]: `${APIGEE_URL[ENVS.QA]}/construction/forms-qa`,
  [ENVS.STAGING]: `${APIGEE_URL[ENVS.STAGING]}/construction/forms`,
  [ENVS.PRODUCTION]: `${APIGEE_URL[ENVS.PRODUCTION]}/construction/forms`,
};

export const BIM360_HOSTNAMES: Record<Env, string> = {
  [ENVS.QA]: 'b360-qa.autodesk.com',
  [ENVS.STAGING]: 'b360-staging.autodesk.com',
  [ENVS.PRODUCTION]: 'b360.autodesk.com',
};

export const BIM360_EMEA_HOSTNAMES: Record<Env, string> = {
  [ENVS.QA]: '',
  [ENVS.STAGING]: 'b360-staging.eu.autodesk.com',
  [ENVS.PRODUCTION]: 'b360.eu.autodesk.com',
};
